import { Space, Tag, Typography } from 'antd';

export const resolveTradeStateMeta = (status, tradeState) => {
  const normalizedStatus = String(status || '').toLowerCase();
  const normalizedState = String(tradeState || '').toUpperCase();
  if (
    normalizedStatus === 'success'
    || normalizedState === 'SUCCESS'
    || normalizedState === 'TRADE_SUCCESS'
    || normalizedState === 'TRADE_FINISHED'
  ) {
    return { text: '已支付', color: 'green' };
  }
  if (normalizedState === 'USERPAYING' || normalizedState === 'NOTPAY' || normalizedState === 'WAIT_BUYER_PAY') {
    return { text: '待支付', color: 'gold' };
  }
  if (
    normalizedState === 'CLOSED'
    || normalizedState === 'REVOKED'
    || normalizedState === 'TRADE_CLOSED'
    || normalizedStatus === 'failed'
  ) {
    return { text: '已关闭', color: 'default' };
  }
  if (!normalizedState && !normalizedStatus) {
    return { text: '-', color: 'default' };
  }
  return { text: normalizedState || normalizedStatus, color: 'blue' };
};

const CREDIT_ENTRY_META_MAP = {
  grant: { label: '会员赠送', color: 'blue' },
  purchase: { label: '购买充值', color: 'green' },
  consume: { label: '生产扣减', color: 'volcano' },
  refund: { label: '扣减返还', color: 'cyan' },
  expire: { label: '积分过期', color: 'default' },
  freeze: { label: '积分冻结', color: 'gold' },
  unfreeze: { label: '积分解冻', color: 'geekblue' },
};

const CREDIT_BUCKET_META_MAP = {
  gift: { label: '赠送', color: 'blue' },
  paid: { label: '购买', color: 'gold' },
  mixed: { label: '混合', color: 'purple' },
};

export const buildSubscriptionHistoryColumns = ({ planNameMap, formatDateTime, formatPaymentAmount }) => ([
  {
    title: '套餐',
    key: 'plan',
    width: 180,
    render: (_, record) => {
      const planId = String(record?.plan_id || '').trim();
      const planName = String(record?.plan_name || '').trim() || planNameMap[planId] || planId || '-';
      return (
        <Space direction="vertical" size={0}>
          <Typography.Text strong>{planName}</Typography.Text>
          {planId && <Typography.Text type="secondary">ID: {planId}</Typography.Text>}
        </Space>
      );
    },
  },
  {
    title: '订阅周期',
    key: 'period',
    width: 220,
    render: (_, record) => (
      <Space direction="vertical" size={0}>
        <Typography.Text>{formatDateTime(record?.period_start)}</Typography.Text>
        <Typography.Text type="secondary">至 {formatDateTime(record?.period_end)}</Typography.Text>
      </Space>
    ),
  },
  {
    title: '支付',
    key: 'payment',
    width: 180,
    render: (_, record) => (
      <Space direction="vertical" size={0}>
        <Typography.Text>{formatPaymentAmount(record?.amount_cents, record?.currency)}</Typography.Text>
        <Typography.Text type="secondary">{formatDateTime(record?.paid_at)}</Typography.Text>
      </Space>
    ),
  },
  {
    title: '状态',
    key: 'status',
    width: 110,
    render: (_, record) => {
      const meta = resolveTradeStateMeta(record?.status, record?.trade_state);
      return <Tag color={meta.color}>{meta.text}</Tag>;
    },
  },
  {
    title: '订单号',
    dataIndex: 'payment_id',
    key: 'payment_id',
    width: 320,
    render: (value, record) => (
      <Typography.Text
        className="billing-order-id"
        type="secondary"
        title={value || record?.out_trade_no || ''}
      >
        {value || record?.out_trade_no || '-'}
      </Typography.Text>
    ),
  },
]);

export const buildCreditHistoryColumns = ({ formatDateTime }) => ([
  {
    title: '类型',
    dataIndex: 'entry_type',
    key: 'entry_type',
    width: 130,
    render: (value) => {
      const meta = CREDIT_ENTRY_META_MAP[String(value || '').trim()] || { label: value || '-', color: 'default' };
      return <Tag color={meta.color}>{meta.label}</Tag>;
    },
  },
  {
    title: '账户',
    dataIndex: 'bucket',
    key: 'bucket',
    width: 90,
    render: (value) => {
      const meta = CREDIT_BUCKET_META_MAP[String(value || '').trim()] || { label: value || '-', color: 'default' };
      return <Tag color={meta.color}>{meta.label}</Tag>;
    },
  },
  {
    title: '变动',
    dataIndex: 'signed_amount',
    key: 'signed_amount',
    width: 100,
    render: (value) => {
      const amount = Number(value || 0);
      const positive = amount > 0;
      const color = positive ? '#389e0d' : (amount < 0 ? '#cf1322' : 'rgba(0, 0, 0, 0.65)');
      const prefix = positive ? '+' : '';
      return <Typography.Text style={{ color, fontWeight: 700 }}>{`${prefix}${amount}`}</Typography.Text>;
    },
  },
  {
    title: '来源',
    key: 'source',
    ellipsis: true,
    render: (_, record) => {
      const flowCode = String(record?.flow_code || '').trim();
      if (flowCode === 'source_to_short_video') return '短视频生产';
      if (flowCode === 'source_to_xhs_note') return '小红书笔记生产';
      if (flowCode === 'source_to_wechat_article') return '公众号文章生产';
      if (String(record?.source_type || '').trim() === 'subscription_cycle') return '会员周期发放';
      if (String(record?.source_type || '').trim() === 'credit_pack_order') return '积分包购买';
      return record?.source_type || '-';
    },
  },
  {
    title: '时间',
    key: 'time',
    width: 180,
    render: (_, record) => formatDateTime(record?.applied_at || record?.created_at),
  },
]);
